module.exports = __webpack_public_path__ + "static/media/tipo3.65212ad4.png";